import { useAuth } from '../context/AuthContext';
import { useLanguage } from '../context/LanguageContext';
import { Clock, LogOut } from 'lucide-react';
import { Button } from './ui/button';

const InactivityWarning = () => {
  const { showInactivityWarning, dismissInactivityWarning, logout } = useAuth();
  const { language, localize } = useLanguage();

  if (!showInactivityWarning) return null;

  return (
    <div className="fixed inset-0 z-[999] bg-black/60 flex items-center justify-center p-4" data-testid="inactivity-warning">
      <div className="bg-white rounded-2xl shadow-2xl max-w-sm w-full p-6 text-center space-y-4 animate-in fade-in zoom-in duration-300">
        <div className="w-16 h-16 rounded-full bg-orange-100 flex items-center justify-center mx-auto">
          <Clock className="w-8 h-8 text-orange-500" />
        </div>
        <h3 className="text-xl font-bold text-slate-800">
          {localize({ ar: 'هل أنت هنا؟', en: 'Are you still here?' })}
        </h3>
        <p className="text-slate-500 text-sm">
          {localize({ ar: 'سيتم تسجيل خروجك تلقائياً خلال دقيقتين بسبب عدم النشاط', en: 'You will be logged out in 2 minutes due to inactivity' })}
        </p>
        <div className="flex gap-3 justify-center">
          <Button 
            onClick={dismissInactivityWarning}
            className="bg-emerald-500 hover:bg-emerald-600 text-white rounded-full px-6"
            data-testid="stay-logged-in-btn"
          >
            {localize({ ar: 'ابقِ جلستي', en: 'Stay Logged In' })}
          </Button>
          <Button 
            variant="outline" 
            onClick={() => { logout(); window.location.href = '/login'; }}
            className="rounded-full px-6 text-slate-500"
            data-testid="logout-now-btn"
          >
            <LogOut className="w-4 h-4 mr-1" />
            {localize({ ar: 'تسجيل خروج', en: 'Logout' })}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default InactivityWarning;
